import type { FC, PropsWithChildren } from 'react'

import styled from '@emotion/styled'

import HeroBase, * as HeroSection from '@segment/matcha/recipes/Hero'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

interface HeroProps {
  title?: string
  description?: string
}

const Hero: FC<PropsWithChildren<HeroProps>> = ({ title, description }) => {
  return (
    <Wrapper>
      <HeroBase variant="article">
        <HeroSection.Contents>
          <CopyTextBase>
            {title && (
              <CopyText.Heading tag="h1" variant="h1">
                {title}
              </CopyText.Heading>
            )}
            {description && (
              <CopyText.Description tag="p" variant="pExtraLarge">
                {description}
              </CopyText.Description>
            )}
          </CopyTextBase>
        </HeroSection.Contents>
      </HeroBase>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  background: ${({ theme }) => theme.palette.twilio.gray[10]};
`

export default Hero
